import TenantLists from "../TenantLists";
import EndpointTimeRangeControls from "../Endpoints/DeviceDetails/EndpointTimeRangeControls";
import "./DashboardAnalytics.css";

interface DashboardAnalyticsFiltersProps {
  onTenantChange: (value: string) => void;
  timeRange: string;
  onTimeRangeChange: (value: string) => void;
  onRefresh: () => void;
  refreshDisabled?: boolean;
}

export default function DashboardAnalyticsFilters({
  onTenantChange,
  timeRange,
  onTimeRangeChange,
  onRefresh,
  refreshDisabled,
}: DashboardAnalyticsFiltersProps) {
  return (
    <div className="overview-card dashboard-analytics-filters">
      <TenantLists variant="card" onSelectorChange={onTenantChange} />
      <div className="dashboard-analytics-filter-divider" aria-hidden="true" />
      <div className="dashboard-analytics-time-controls">
        <EndpointTimeRangeControls
          value={timeRange}
          onValueChange={onTimeRangeChange}
          onRefresh={onRefresh}
          refreshDisabled={refreshDisabled}
        />
      </div>
    </div>
  );
}
